import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { PowerSelectNoMatchesMessageSignature } from 'ember-power-select/components/power-select/no-matches-message';

import type {
  Group,
  Option,
} from '../../../../types/components/prism/combo-select-input.ts';
import PrismButton from '../../button.gts';

interface PrismComboSelectInputUnsafeCreateWhenNoMatchesActionArgs {
  buildLabelWithSearchText: (searchText: string) => string;
  dataTestId: string;
  onClick: (searchText: string) => unknown;
}

interface PrismComboSelectInputUnsafeCreateWhenNoMatchesActionSignature {
  Args: PowerSelectNoMatchesMessageSignature<Option, Group<Option>>['Args'] &
    PrismComboSelectInputUnsafeCreateWhenNoMatchesActionArgs;
}

export default class PrismComboSelectInputUnsafeCreateWhenNoMatchesAction extends Component<PrismComboSelectInputUnsafeCreateWhenNoMatchesActionSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get label() {
    return this.args.buildLabelWithSearchText(this.args.select.searchText);
  }

  @action
  handleClick(): void {
    this.args.select.actions.close();
    this.args.onClick(this.args.select.searchText);
  }

  <template>
    <div class="dropdown__unsafe-create-when-no-matches-action">
      <PrismButton
        @buttonType="secondary"
        @label={{this.label}}
        @onClick={{this.handleClick}}
        data-test-id={{@dataTestId}}
      />
    </div>
  </template>
}
